import { Container, Row, Col } from '../../components/atoms/Grid';
import NewsCard from './NewsCard';
import Text from '../../components/atoms/Text';
import Button from '../../components/atoms/Button';
import { Spin } from 'antd';
import { sbEditable } from '@storyblok/storyblok-editable';
import { useCallback, useRef, useEffect, useState } from 'react';
import Colors from 'components/tokens/Colors';
import { LoadingOutlined } from '@ant-design/icons';

function NewsList(props) {
    const [obs, setObs] = useState(false);
    const news = props.content;

    const total = props.total;

    const setNextPage = useCallback(
        page => {
            props.onMoreNews && props.onMoreNews(page);
        },
        [props]
    );

    const setNewContent = useCallback(
        content => {
            props.onNewContent && props.onNewContent(content);
        },
        [props]
    );

    const setElasticSearchFrom = useCallback(
        number => {
            props.onUpdateFrom && props.onUpdateFrom(number);
        },
        [props]
    );

    const newContentRef = useRef(props.newContent);

    useEffect(() => {
        newContentRef.current = props.newContent;
    }, [props.newContent]);

    const elasticSearchFromRef = useRef(props.elasticSearchFrom);

    useEffect(() => {
        elasticSearchFromRef.current = props.elasticSearchFrom;
    }, [props.elasticSearchFrom]);

    const handleLoadMore = () => {
        const intersectionObserver = new IntersectionObserver(entries => {

            if (entries.some(entry => entry.isIntersecting)) {
                setElasticSearchFrom(elasticSearchFromRef.current + 10);
                if (newContentRef.current && props.onNewContent) {
                  setNextPage(currentValue => currentValue + 1);
                  setNewContent(false);
                }
            }
            setObs(true)
        });
        intersectionObserver.observe(document.querySelector('#aux'));
        return () => {
          intersectionObserver.disconnect();
          setObs(false)
        };
    };

    return (
        <Container {...sbEditable(props)} id="init">
            <Row mt="10" mb="8">
                <Col size="12">
                    <Row mb="6.4">
                        <Col>
                            {news?.length === 0 || total === 0 ? (
                                <Text body2>Nenhum texto foi encontrado</Text>
                            ) : (
                                <Text body2>
                                    {props.text} <b>{props.highlightedText && `"${props.highlightedText}"`}</b>
                                </Text>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col size="12" order="1 3">
                            <NewsCard
                                data={news}
                                name={props.name}
                                hasTags={props.hasTags}
                                hideAuthor={props.hideAuthor}
                            />
                        </Col>
                    </Row>

                    {news?.length === 0 || news?.length === total ? null : (
                        <Row justifyContent="center" mt="5">
                            <Col size="auto" style={{ position: 'relative' }}>
                                <div id="aux" style={{ width: '10px', height: '50px', marginTop: '-50px', position: 'absolute' }}/>
                                <div style={{ height: '55.7833px' }}>
                                    <Button dark disabled={obs} onClick={() => handleLoadMore()}>
                                        { obs ?
                                          <Spin indicator=<LoadingOutlined spin style={{ fontSize: 18, color: Colors.primary, width: "110px" }} /> /> :
                                          "Carregar mais"
                                        }
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    )}
                </Col>
            </Row>
        </Container>
    );
}

export default NewsList;
